export default "__VITE_ASSET__7c54ebd8__"